// src/utils/invoicePrinter.js

export function printInvoiceHTML({
  html,
  title = "Invoice",
  logoUrl = "/my-chinese-horoscope-logo.png",
}) {
  const win = window.open("", "_blank", "width=900,height=700");
  if (!win) return;

  win.document.write(`
<!DOCTYPE html>
<html>
<head>
  <title>${title}</title>
  <meta name="viewport" content="width=device-width, initial-scale=1" />

  <style>
    * { box-sizing: border-box; }
    body {
      font-family: Arial, Helvetica, sans-serif;
      color: #000;
      margin: 0;
      padding: 24px;
      background: #fff;
    }

    /* Header */
    .printHeader {
      display: flex;
      align-items: center;
      gap: 16px;
      border-bottom: 2px solid #eee;
      padding-bottom: 12px;
      margin-bottom: 20px;
    }
    .printLogo {
      height: 60px;
    }
    .printBrand {
      font-size: 18px;
      font-weight: 900;
    }

    /* Invoice styles (match preview) */
    .accInvoiceWrap { max-width: 900px; margin: 0 auto; }
    .accInvoiceTop {
      display: flex;
      justify-content: space-between;
      gap: 20px;
      flex-wrap: wrap;
      margin-bottom: 16px;
    }
    .accInvoiceMeta div {
      font-size: 12px;
      margin: 3px 0;
    }
    .accInvoiceTable {
      border: 1px solid #ddd;
      border-radius: 10px;
      overflow: hidden;
    }
    .accInvoiceRowHead,
    .accInvoiceRow {
      display: grid;
      grid-template-columns: 1fr 160px;
      gap: 12px;
      padding: 12px 14px;
    }
    .accInvoiceRowHead {
      background: #f7f7f7;
      font-weight: 700;
      font-size: 12px;
    }
    .accInvoiceRow {
      border-top: 1px solid #eee;
      font-size: 12px;
    }
    .accRight { text-align: right; }
    .accMoney { font-variant-numeric: tabular-nums; }

    .accInvoiceTotals {
      border-top: 1px solid #eee;
      padding: 12px 14px;
    }
    .accTotalLine,
    .accTotalLineGrand {
      display: flex;
      justify-content: space-between;
      margin: 6px 0;
      font-size: 12px;
    }
    .accTotalLineGrand {
      font-weight: 900;
      font-size: 14px;
      margin-top: 10px;
    }

    @media print {
      body { padding: 0; }
    }
  </style>
</head>

<body>
  <div class="printHeader">
    <img class="printLogo" src="${logoUrl}" />
    <div class="printBrand">MyChineseHoroscope</div>
  </div>

  ${html}

  <script>
    window.onload = function () {
      window.focus();
      window.print();
    };
  </script>
</body>
</html>
  `);

  win.document.close();
}
